import { Engine, SceneOptions, StandardMaterial, Vector3 } from '@babylonjs/core';
import { ICamera } from 'Framework/Components/Controls/XView/Cameras';
import { IPanoramaConfiguration } from 'Framework/Components/Controls/XView/Core';
import { TextureMaterial, VideoTextureMaterial } from 'Framework/Components/Controls/XView/Materials';
import { MeshBuilder } from 'Framework/Components/Controls/XView/MeshBuilder';
import { BaseRenderer } from 'Framework/Components/Controls/XView/Renderers/BaseRenderer';
import { UIElement } from 'Framework/Components/UIElement';

export class Sphere360Renderer extends BaseRenderer<IPanoramaConfiguration> {
    public constructor(engine: Engine, camera: ICamera, options?: SceneOptions) {
        super(engine, camera, options);
    }

    protected override onLoad(configuration: IPanoramaConfiguration): void {
        this.camera.lookTo(configuration.startOrientation);

        let sphere = MeshBuilder.createSphere('sphere1', this);
        sphere.setAbsolutePosition(Vector3.Zero());

        let material: StandardMaterial = null;

        if (configuration.Url.includes('video')) {
            // .mp4, .webm, and .ogv 
            const videoMaterial = new VideoTextureMaterial('video', this, configuration.Url);

            this.onPointerDown = (evt, pi) => {
                this._isCameraMoving = false;
            };

            this.onPointerMove = (evt, pi) => {
                this._isCameraMoving = true;
            };

            this.onPointerUp = async (evt, pi) => {
                if (this._isCameraMoving) {
                    return;
                }

                if (videoMaterial.video.paused) {
                    await videoMaterial.video.play();
                }
                else {
                    videoMaterial.video.pause();
                }
            };

            material = videoMaterial;
        }
        else {
            material = new TextureMaterial('texture', this, configuration.Url);
        }

        sphere.material = material;

        UIElement.Bus.$emit('preview-loaded');
    }

    private _isCameraMoving: boolean;
}
